var _rect, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconHorizontalBar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.499969,
    width: 41,
    height: 41,
    rx: 7.5,
    stroke: "var(--report-widget-icon-stroke-outer)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 12.8,
    width: 3,
    height: 8,
    transform: "rotate(90 20 12.8)",
    fill: "var(--report-widget-icon-stroke-dark)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 19.7,
    width: 3,
    height: 18,
    transform: "rotate(90 30 19.7)",
    fill: "#FF6D10"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 26.5,
    width: 3,
    height: 12,
    transform: "rotate(90 24 26.5)",
    fill: "var(--report-widget-icon-stroke-dark)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHorizontalBar);
export default __webpack_public_path__ + "static/media/icon-horizontal-bar.8e349794aef35b3a415df2f345c2ec72.svg";
export { ForwardRef as ReactComponent };